module.exports = __webpack_public_path__ + "img/lixisenatide_7.b8bfe688.jpg";